import { type PropsWithChildren } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import clsx from 'clsx';

import { Button } from '../Button';

import styles from './styles/Popover.module.scss';

const Popover = ({ children, ...props }: PropsWithChildren & RadixPopover.PopoverProps) => {
  return <RadixPopover.Root {...props}>{children}</RadixPopover.Root>;
};
const PopoverTrigger = ({
  children,
  className,
  ...props
}: { className?: string } & PropsWithChildren & RadixPopover.PopoverTriggerProps) => {
  return (
    <RadixPopover.Trigger asChild data-testid="popover-trigger" {...props}>
      <Button className={clsx(styles.trigger, className)} variant="ghost">
        {children}
      </Button>
    </RadixPopover.Trigger>
  );
};
const PopoverContent = ({
  children,
  className,
  ...props
}: { className?: string } & PropsWithChildren & RadixPopover.PopoverContentProps) => {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        className={clsx(styles.popoverContent, className)}
        collisionPadding={8}
        data-cxy-name="popover"
        data-testid="popover-content"
        sideOffset={5}
        {...props}
      >
        {children}
      </RadixPopover.Content>
    </RadixPopover.Portal>
  );
};

Popover.Trigger = PopoverTrigger;
Popover.Content = PopoverContent;

export { Popover };
